import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 36, className = "", hover = false }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...(hover ? { whileHover: { y: -6, transition: { duration: 0.25, ease: "easeOut" } } } : {})}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, lineClassName = "", delay = 0.15, as: Tag = "h1", testId }) {
  const MotionTag = motion[Tag] || motion.h1;
  return (
    <MotionTag className="font-heading" data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.09em] -mb-[0.09em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "112%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, delay: delay + i * 0.13, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
}

export function Chapter({ number, overline, title, className = "", testId }) {
  return (
    <div className={`relative ${className}`} data-testid={testId}>
      <span
        aria-hidden="true"
        className="pointer-events-none select-none absolute -top-16 -left-2 font-heading text-[9rem] lg:text-[13rem] leading-none font-extrabold text-gray-100"
      >
        {number}
      </span>
      <div className="relative">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.22em] font-semibold text-brand">{overline}</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-4 font-heading text-4xl lg:text-5xl tracking-tight text-gray-950 max-w-2xl">
            {title}
          </h2>
        </Reveal>
      </div>
    </div>
  );
}

export function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-gray-200 bg-[#F8F9FA] py-7" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="outline-text font-heading text-4xl lg:text-6xl font-bold tracking-tight px-8">
                  {item}
                </span>
                <span aria-hidden="true" className="h-2 w-2 rounded-full bg-brand" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
